import emailjs from '@emailjs/browser';
import type { ContactFormValues } from '@/lib/validation';

const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID as string;
const TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID as string;
const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY as string;

export async function sendContactEmail(values: ContactFormValues): Promise<void> {
  if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
    throw new Error(
      'EmailJS não está configurado. Verifique as variáveis VITE_EMAILJS_* no .env.'
    );
  }

  await emailjs.send(
    SERVICE_ID,
    TEMPLATE_ID,
    {
      name: values.nome,
      email: values.email,
      phone: values.telefone ?? '',
      message: values.mensagem ?? '',
      isComunicationAgreed: values.comunicacoes ? 'Sim' : 'Não',
      isPrivacyTermAgreed: values.privacidade ? 'Sim' : 'Não',
      time: new Date().toLocaleString('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short',
      }),
    },
    { publicKey: PUBLIC_KEY }
  );
}
